function t(n){const o={};for(const e in n)n[e]&&"object"==typeof n[e]?o[e]=t(n[e]):null!==n[e]&&""!==n[e]&&(o[e]=n[e]);return o}export{t as default};
//# sourceMappingURL=removeEmpty.js.map
